// import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const ContainerFluid = styled.div`
// border:2px dashed red;
width:100%;
min-height:502px;
background: linear-gradient(-113.57deg, rgba(0, 165, 104, 0.5) 22.35%, rgba(0, 165, 104, 0.1) 71.76%);
`;


export const Container = styled.div
.attrs(() => ({
  className: 'container-custom',
}))`
min-height: 396px;
`;
export const ContainerX = styled.div
.attrs(() => ({
  className: 'container-custom',
}))`
width:91% !important;
`;



export const HeadingText = styled.h1
.attrs(() => ({
  className: '',
}))`
// width: 359px;
min-height: 38px;
font-family: 'Cabinet Grotesk-bold';
font-style: normal;
font-weight: 800;
font-size: 40px;
line-height: 103%;
color: #282828;
margin-bottom:0px !important;
@media screen and (max-width: 425px) {
    width:auto !important;
}

`;



export const DescText = styled.p
.attrs(() => ({
  className: '',
}))`
font-family: 'Cabinet Grotesk-regular', roboto;
font-style: normal;
font-weight: 800;
font-size:20px;
line-height: 142.5%;
color: #4A4A4A;
b{
font-family: 'Cabinet Grotesk-b', roboto;
font-weight: 500;
}
@media screen and (max-width: 425px) {
    width:auto !important;
}
`;